/**
 * Resolves a design token to a literal colour a canvas can use.
 *
 * The semantic tokens are CSS custom properties, and `fillStyle` cannot read one - assigning
 * `var(--surface-default)` is silently ignored and the canvas keeps whatever colour it had.
 * Reading the computed value off an element in the tree gives the theme in force at the moment
 * of the call, rather than freezing whichever hex was hardcoded. Following a later theme switch
 * is the caller's problem: this resolves once, when asked.
 *
 * Values that are already literal pass straight through, so a caller can hand over a hex.
 */
export const resolveCssColor = (
  element: Element | null,
  token: string,
  fallback: string
): string => {
  const match = /^var\((--[^,)]+)/.exec(token.trim());
  if (!match) return token;
  if (!element) return fallback;

  const resolved = getComputedStyle(element).getPropertyValue(match[1]).trim();

  return resolved === '' ? fallback : resolved;
};
